<script lang="ts" setup>
  import { IonicSafeString } from '@ionic/vue'
  import type { AlertButton } from './types'
  import { sanitizeString } from '~/utils/string'

  const props = withDefaults(
    defineProps<{
      isOpen?: boolean
      header?: string
      subHeader?: string
      message?: string
      backdropDismiss?: boolean
      buttons?: AlertButton[]
    }>(),
    {
      isOpen: false,
      header: '',
      subHeader: '',
      message: '',
      backdropDismiss: true,
      buttons: undefined
    }
  )

  defineEmits<{
    (event: 'did-dismiss'): void
    (event: 'will-dismiss'): void
  }>()

  const defaultButton: AlertButton[] = [
    {
      text: 'GOTCHA',
      handler: () => null
    }
  ]

  const sanitisedMessage = computed<IonicSafeString>(() => {
    if (props.message === undefined) return new IonicSafeString('')
    return new IonicSafeString(sanitizeString(props.message))
  })
</script>

<template>
  <ion-alert
    :backdrop-dismiss="backdropDismiss"
    :buttons="buttons ? buttons : defaultButton"
    :header="header"
    :is-open="isOpen"
    :message="sanitisedMessage.value"
    :sub-header="subHeader"
    class="g-alert"
    mode="md"
    @did-dismiss="$emit('did-dismiss')"
    @will-dismiss="$emit('will-dismiss')"
  />
</template>

<style lang="scss" scoped>
  :deep(.alert-wrapper) {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px;

    border-radius: 0;

    .alert-head,
    .alert-message,
    .alert-button-group {
      padding: 0;
    }

    .alert-message {
      @include typography-body;
    }

    .alert-title {
      @include typography-header-4;
    }

    .alert-button-group {
      display: flex;
      column-gap: 12px;

      .alert-button {
        flex: 1 1 auto;
        border-radius: 4px;
        background-color: var(--color-base-red);
        color: var(--color-base-white);
        margin-right: 0;
        font-weight: 700;

        &.alert-button-secondary {
          background-color: var(--color-base-white);
          border-color: var(--color-base-red);
          color: var(--color-base-red);
        }

        .alert-button-inner {
          justify-content: center;
        }
      }
    }
  }
</style>
